import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"

const getUniqueLeadIntegrationLogRows = (rows = []) => {
  const uniqueRows = []

  rows.forEach((item) => {
    const existingIndex = uniqueRows.findIndex((existingItem) => existingItem.id == item.id)

    if (existingIndex <= -1) {
      uniqueRows.push(item)
    }
  })

  return uniqueRows
}

export const handleGetLeadIntegrationLogsById = (state, action) => {
  let page_number = 1
  if (action.paginated) {
    page_number = action.payload?.queryParams?.page_number || 1
  }

  const useCache = Boolean(action.payload?.useCache)
  const queryParams = action.payload?.queryParams || {}
  const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
  const shouldResetCache =
    useCache &&
    page_number === 1 &&
    !action.payload?.appendResults &&
    state.lead_integration_logs_active_cache_key &&
    state.lead_integration_logs_active_cache_key !== cacheKey
  const cachedPage = useCache ? state.lead_integration_logs_page_cache?.[cacheKey]?.[page_number] : null
  const shouldReplaceResults = Boolean(action.payload?.replaceResults)

  return {
    ...state,
    lead_integration_logs_by_id_error: null,
    lead_integration_logs_active_cache_key: useCache ? cacheKey : null,
    lead_integration_logs_by_id_loading: !cachedPage,
    lead_integration_logs_by_id: cachedPage?.rows || (
      (page_number === 1 || shouldReplaceResults || !action.payload?.appendResults)
        ? []
        : state.lead_integration_logs_by_id
    ),
    lead_integration_logs_by_id_last_page_fetched: cachedPage?.page_number || state.lead_integration_logs_by_id_last_page_fetched,
    lead_integration_logs_total_number_of_pages: cachedPage?.total_number_of_pages || state.lead_integration_logs_total_number_of_pages,
    has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
    lead_integration_logs_has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean'
      ? cachedPage.has_lookahead_pages
      : state.lead_integration_logs_has_lookahead_pages,
    lead_integration_logs_page_cache: shouldResetCache ? {} : state.lead_integration_logs_page_cache,
  }
}

export const handleGetLeadIntegrationLogsByIdSuccess = (state, action) => {
  const payloadData = action.payload.data
  const rows = Array.isArray(payloadData) ? payloadData : []
  const additional = action.payload.additional_data || {}
  const useCache = Boolean(action.meta?.useCache)
  const queryParams = action.meta?.queryParams || {}
  const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
  const appendResults = Boolean(action.meta?.appendResults)
  const replaceResults = Boolean(action.meta?.replaceResults)
  const pageNum = parseInt(additional.page_number, 10)
  const totalPages = parseInt(additional.total_number_of_pages, 10)
  const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
  const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
  const hasNextPage =
    typeof additional.has_next_page === 'boolean'
      ? additional.has_next_page
      : false
  const hasLookAheadPages =
    typeof additional.has_lookahead_pages === 'boolean'
      ? additional.has_lookahead_pages
      : false
  const pageSnapshot = {
    rows,
    page_number: safePage,
    total_number_of_pages: safeTotal,
    has_next_page: hasNextPage,
    has_lookahead_pages: hasLookAheadPages,
  }

  let leadIntegrationLogs = rows
  if (appendResults && !replaceResults) {
    leadIntegrationLogs = getUniqueLeadIntegrationLogRows([...state.lead_integration_logs_by_id, ...rows])
  }

  return {
    ...state,
    lead_integration_logs_by_id: leadIntegrationLogs,
    lead_integration_logs_by_id_last_page_fetched: safePage,
    lead_integration_logs_total_number_of_pages: safeTotal,
    has_next_page: hasNextPage,
    lead_integration_logs_has_lookahead_pages: hasLookAheadPages,
    lead_integration_logs_active_cache_key: useCache ? cacheKey : state.lead_integration_logs_active_cache_key,
    lead_integration_logs_by_id_loading: false,
    lead_integration_logs_page_cache: useCache ? {
      ...state.lead_integration_logs_page_cache,
      [cacheKey]: {
        ...(state.lead_integration_logs_page_cache?.[cacheKey] || {}),
        [safePage]: pageSnapshot,
      },
    } : state.lead_integration_logs_page_cache,
  }
}

export const handleGetLeadIntegrationLogsByIdError = (state, action) => ({
  ...state,
  lead_integration_logs_by_id_error: action.payload,
  lead_integration_logs_by_id_loading: false,
  has_next_page: false,
  lead_integration_logs_has_lookahead_pages: false,
})
